var fitt = require('fitt'),
getDispatch = require('./defaults.js').getDispatch,
PromiseRetry = require('fitt-promise-retry'),
debug = require('debug')('fitt-http'),
ECONNABORTED = 'ECONNABORTED',
ERR_MULTIPLIER = 1.65,
traceWrap,writer,
promiseRetry;

/**
               * Internal function that handles returned promise from dispatch and request preparations
               *
               * @name fitt-http#sendRequest
               * @function
               * @param {String} url - The resource to request
               * @param {Object} config - The object containing all incoming config parameters
               * @return {Promise}
               */

function sendRequest(url, config) {

	// Flatten headers
	config.headers = fitt.mix({}, [config.method_headers[config.method] || {}, config.headers || {}]);

	var dispatch = getDispatch(config.dispatch),
	attempts = config && config.attempts,
	retryConfig;

	if (config.transformRequest) {
		fitt.forEach(config.transformRequest, function (fn) {
			config.data = fn(config.data, config.headers);
		});
	}

	if (config.tracing) {
		if (!process.browser) {// Enable http tracing on server-only
			traceWrap = require('./traceWrap');
			dispatch = traceWrap(dispatch, url, config);
		}
	}

	if (attempts) {
		retryConfig = { attempts: attempts };
	}

	function sendRequestRetry(err, retries) {
		// If request times out, try w/ a slightly higher timeout
		if (err && err.code === ECONNABORTED && retries) {
			config = fitt.mix({}, [config, { timeout: getTimeout(config.timeout, retries) }]);
		}
		return dispatch(url, config);
	}

	promiseRetry = new PromiseRetry(sendRequestRetry, retryConfig);

	return promiseRetry.try().then(
	function (response) {
		debug('Response received', url, response.status);

		// Validate? Transform?
		if (config.transformResponse) {
			fitt.forEach(config.transformResponse, function (fn) {
				response.data = fn(response.data, response.headers);
			});
		}

		// Write response to disk?
		if (!process.browser) {
			if (config.writeResponse) {
				writer = require('./fileWriter');
				writer(config.writeResponse, response);
			}
		}

		return response;
	},
	function (reason) {
		return Promise.reject(reason);
	});

}

/**
   * Calculate request timeout based on retries
   *
   * @param  {Number} timeout  Original timeout
   * @param  {Number} retries  Number of times, request was retried
   * @return {Number}
   */

function getTimeout(timeout, retries) {
	return Math.floor(timeout * Math.pow(ERR_MULTIPLIER, retries));
}

if (typeof module !== fitt.TYPE_UNDEF) {
	module.exports = sendRequest;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/sendRequest.js
// module id = 814
// module chunks = 0